import { HeaderTextProps } from 'components/organisms/Header/types';

const header: HeaderTextProps = {
    headerText: {
        greetings: 'こんにちは',
        intro: "私は",
        preTitle: '',
    },
    scrollDown: '下にスクロール',
};

export default header;
